import React from 'react';
import { Link } from 'react-router';

const EventCard = ({event: {id, name, location, schedule, passes, trackName}}) => (
  <Link to={`event/${id}`} className="panel-link">
    <div className="panel panel-card panel-card-lg">
      <div className="panel-body text-center">
        <div data-track={trackName}></div>
        <h4>{name}</h4>
        <span>{location}</span>
        <br />
        <span>{schedule}</span>
        <br />
        <span className="card-counts">
          <span><span className="color-guest">Guest{' '}({passes.paddock_guest_wristband + passes.vendor_guest_wristband + passes.broadcast_guest_wristband + passes.hotpit_guest })</span></span>
          <span><span className="color-single">Single{' '}({passes.media_single + passes.working_single})</span></span>
          <span><span className="color-model">Model{' '}({passes.model})</span></span>
        </span>
        <div className="icon-gray_arrow_forward panel-cta"></div>
      </div>
    </div>
  </Link>
);

export default EventCard;



// WEBPACK FOOTER //
// ./src/components/Events/EventCard.js